import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { GetInvoiceListPagingAndFilterRequest } from '../../../models/request/invoice/GetInvoiceListPagingAndFilterRequest';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import ColumnChooser from '../../ColumnChooser';
import ExcelExportMenu from '../../ExcelExportMenu';
import { ExcelExportMode } from '../../../helpers/excelExportRequest';
import TableActions from '../../TableActions';
import TableConstantActions from '../../TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetInvoiceListPagingAndFilterRequest
    getData: (_filter?: GetInvoiceListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetInvoiceListPagingAndFilterRequest>>
    isSale: boolean
    isPurchase: boolean
    isRefund: boolean
    selectedCount: number
    sendToUyumsoft: (_sendToGib: boolean) => Promise<void>
    cancelDraftInvoice: () => Promise<void>
    cancelEArsivInvoice: () => void
    eArsivSecili: boolean
    moveToDraftInvoice: () => Promise<void>
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
}

const CommonInvoiceListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
    isSale,
    isPurchase,
    isRefund,
    selectedCount,
    sendToUyumsoft,
    cancelDraftInvoice,
    cancelEArsivInvoice,
    eArsivSecili,
    moveToDraftInvoice,
    deleteFunction,
    updateFunction,
    onSearchSubmit
}: Props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            {/* Arama kutusu + Güncelle/Sil düğmeleri artık üst şeritte (liste ekranı standardı). */}
            <TableConstantActions
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                hideSearch={true}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            <TableActions
                list={[
                    { isDisabled: selectedCount != 1, text: "Uyumsoft Taslak (e-Fatura / e-Arşiv)", onClick: () => sendToUyumsoft(false) },
                    { isDisabled: selectedCount != 1, text: "GİB'e Gönder (e-Fatura / e-Arşiv)", onClick: () => sendToUyumsoft(true) },
                    { isDisabled: selectedCount != 1, text: "E-Fatura Geri Çekme (Uyumsoft)", onClick: cancelDraftInvoice },
                    { isDisabled: selectedCount != 1, text: "E-Fatura Taslağa Çevir (Uyumsoft)", onClick: moveToDraftInvoice },
                    { isDisabled: !eArsivSecili, text: "e-Arşiv İptal (Uyumsoft)", onClick: cancelEArsivInvoice },
                ]}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            {/* Filtreler paneli kaldırıldı (22.09.2026): Cari Ünvanı, Operasyon Türü, Döviz Cinsi,
                Fatura Durumu, Fatura Tarihi ve Ödeme Tarihi kolon başlığının altındaki filtrede var. */}

            <React.Fragment>
                {
                    auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                        <div className='m-0'>
                            <a
                                onClick={() => navigate(`/${(isSale ? 'sale' : isPurchase ? 'purchase' : isRefund ? 'refund' : '')}invoice/listadd`)}
                                className='btn btn-sm fw-bold btn-primary'
                            >
                                Yeni Fatura Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment>
        </React.Fragment>
    )
}

export default CommonInvoiceListFilters;